/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_LogoutInputs */

const en_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logout`)
};

const ja_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログアウト`)
};

const fr_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déconnexion`)
};

const de_nav_logout = /** @type {(inputs: Nav_LogoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abmelden`)
};

/**
* | output |
* | --- |
* | "Logout" |
*
* @param {Nav_LogoutInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const nav_logout = /** @type {((inputs?: Nav_LogoutInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_LogoutInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_logout(inputs)
	if (locale === "ja") return ja_nav_logout(inputs)
	if (locale === "fr") return fr_nav_logout(inputs)
	return de_nav_logout(inputs)
});